import { observable } from '@legendapp/state';

interface DragOverlayStore {
	isDragOverlayVisible: boolean;
}

export const dragOverlayStore = observable<DragOverlayStore>({
	isDragOverlayVisible: true
});

export const dragOverlayStoreActions = {
	setIsDragOverlayVisible: (bool: boolean) => {
		dragOverlayStore.isDragOverlayVisible.set(bool);
	}
};
